import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { assignTestId } from '@common/infra/tests/assign-test-id';
import { ConstituentLogo } from '../../constituent-logo/constituent-logo';
import { getConstituentName } from '../../constituent-name';
import styles from './constituent-list-item.css';
export function ConstituentListItem(props) {
    const { constituentId } = props;
    return (_jsxs("div", { className: styles.wrapper, ...assignTestId('constituent-list-item'), children: [_jsx(ConstituentLogo, { className: styles.logo, id: constituentId }), _jsx("span", { className: styles.name, children: getConstituentName(constituentId) })] }));
}
